let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9l0DZ")).then(() => parcelRequire('72HZ8'));